export { State, Getter, Action, Mutation, namespace } from './bindings';



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vuex-class@0.3.2@vuex-class/lib/index.js
// module id = ./node_modules/_vuex-class@0.3.2@vuex-class/lib/index.js
// module chunks = 0 1 2 3 4